import React from 'react'
import style from './styles/errorText.module.scss'

const ErrorText = ({ text = '' }): React.ReactElement => {
  return (
    <div slot='help-text' className={style.error__text}>
      {text}
    </div>
  )
}

export default ErrorText
